export interface MetaTagsConfig {
  title: string;
  description: string;
  keywords: string;
}

export interface RouteMetaConfig {
  [key: string]: MetaTagsConfig;
}

export const metaTagsConfig: RouteMetaConfig = {
  "/": {
    title: "86400 | Secure Digital Payments & API Banking Solutions for Banks & Fintechs",
    description: "86400 empowers banks and fintechs with secure digital payment infrastructure and advanced API banking solutions. Enable UPI, IMPS, BBPS, AePS & more with scalable, high-performance payment technology.",
    keywords: "Digital Payments Infrastructure, digital payment system, Secure Payment Solutions, Secure Payments for Bank, Secure Payments for Fintech"
  },
  "/products": {
    title: "86400 | API Banking & Certified Payment Switch Solutions",
    description: "Enable seamless API banking with 86400. Certified payment switches, secure bank API integration, and scalable platforms for fintechs.",
    keywords: "bank api integration, Certified Payment Switches, api banking platform, API Banking"
  },
  "/TransXT": {
    title: "86400 | 86400 TransXT Platform & API Banking Solutions",
    description: "Explore 86400 & TransXT platforms by 86400. Scalable API banking, digital payments TSP services, and next-gen financial infrastructure.",
    keywords: "86400 payments infrastructure, 86400 API Banking platform, TransXT platform, Payments with TransXT, 86400 TSP services, 86400 Technology Service Provider"
  },
  "/products/upi": {
    title: "86400 | Seamless UPI Payments, APIs & TSP Integration",
    description: "Power your business with UPI. 86400 offers UPI APIs, TSP services, seamless UPI Collect, Pay, Payouts, and QR-based transactions.",
    keywords: "upi payment platform, Seamless UPI Payments, UPI Switch, UPI Collect, UPI Payouts provider, upi auto pay, upi api provider, UPI TSP provider, UPI TSP integration services, upi payment api, upi payment gateway api, QR Code Payments in India, scan to pay qr code, upi provider, upi service provider, TSP for UPI switch platform"
  },
  "/products/imps": {
    title: "86400 | IMPS Switch & Instant Payment Solutions",
    description: "Enable instant IMPS transactions with 86400's certified IMPS switch. Scalable solutions for banks, fintechs, and cooperative institutions.",
    keywords: "IMPS Switch, IMPS TSP provider India, NPCI IMPS TSP solutions, P2P Fund Transfer, P2A Fund Transfer, P2M Fund Transfer, IMPS infrastructure, instant merchant payments, imps bank transfer india, imps payment india"
  },
  "/products/bbps": {
    title: "86400 | BBPS Bill Payments & NPCI Certified Switch",
    description: "Simplify bill payments with 86400's BBPS switch. NPCI-certified solutions for secure and fast bill payment processing across India.",
    keywords: "bbps payment, bbps bill, BBPS Switch, bbps online payment, bbps transaction, bill payment services, BBPS TSP provider"
  },
  "/products/aeps": {
    title: "86400 | AePS Aadhaar-enabled Payments & TSP Services",
    description: "Offer Aadhaar-enabled banking services with 86400 AePS solutions. Secure cash withdrawal, balance enquiry, and payment support for banks.",
    keywords: "aeps services, Aadhaar-enabled banking services, aeps cash withdrawal, aeps balance enquiry, aeps payment, aadhaar based cash withdrawal, aadhaar based money withdrawal, NPCI AePS Technology Service Provider, AePS TSP partner for banks"
  },
  "/Careers": {
    title: "86400 | Explore oppourtunies to build your career with us",
    description: "Join 86400 and shape the future of digital payments. Explore job openings and get career growth in one of the leading fintech companies in India.",
    keywords: "careers at 86400, fintech jobs, payment technology careers, digital payment jobs"
  },
  "/Resources/Blogs": {
    title: "86400 | Blogs | Latest news and technologies in Digital Payment Solutions",
    description: "Explore our blog content to get all updates about news, product features, tehnology, payment solutions, customer stories and more.",
    keywords: "digital payment blogs, fintech news, payment technology updates"
  },
  "/Resources/News": {
    title: "86400 | News | Read more about our intiatives and Jourery",
    description: "Read about 86400's journey, launches, achievements, and more. With each new step, our impact grows rapidly.",
    keywords: "86400 news, fintech news, payment technology news"
  },
  "/Resources/Case%20Studies": {
    title: "86400 | Case Studies | Our Digital Payment Solutions",
    description: "Read our case studies to underastand more about our products, launches and more.",
    keywords: "payment solutions case studies, fintech case studies, digital payment success stories"
  },
  "/Blogs/59": {
    title: "Credit Line on UPI: Big Leap in India’s Financial Inclusion Journey",
    description: "Discover how Credit Line on UPI is revolutionizing digital credit access, empowering MSMEs, and driving India’s next wave of financial inclusion.",
    keywords: "credit line on UPI, digital lending India, UPI credit feature, instant credit on UPI, financial inclusion India, fintech innovation India, NPCI credit line, RBI digital credit, UPI Lite X, MSME loans India, UPI-based credit, UPI credit facility, digital credit ecosystem, UPI fintech solutions, mobileware fintech"
  },

  "/Blogs/58": {
    title: "Highlights from GFF 2025 | AI-Powered Fintech & UPI Innovations by 86400",
    description: "Discover key insights from Global Fintech Fest 2025 — AI-led innovation, UPI Lite X, and how 86400 is building the next-gen payments infrastructure for the world.",
    keywords: "global fintech fest 2025, fintech innovation, digital payments infrastructure, upi lite x, AI in fintech, fintech ecosystem India, NPCI fintech updates, UPI for banks, API-led fintech solutions, fintech conferences"
  },

  "/Blogs/57": {
    title: "Simplifying Bill Payments with Bharat Connect | BBPS API & Digital Payment Solutions by 86400",
    description: "Discover how Bharat Connect (formerly BBPS) is transforming digital bill payments across India. Learn how 86400’s secure, real-time BBPS API helps banks, fintechs, and businesses simplify payments, drive inclusion, and build trust.",
    keywords: "Bharat Bill Payment System, UPI bill payment, digital payment platform India, BBPS API integration, Bharat Connect bill payment system, secure bill payment API India, 86400 payment solutions"
  },

  "/Blogs/56": {
    title: "India’s Fintech Future: UPI, AI, and API Banking Trends for 2025 | 86400",
    description: "Explore how India’s fintech ecosystem is evolving through UPI, AI, and API banking. Learn how 86400 empowers digital finance innovation across the nation.",
    keywords: "Fintech in India, Digital payments India, UPI India, Fintech ecosystem, API banking, API integration for banks, Digital finance solutions, 86400 fintech"
  },

  "/Blogs/54": {
    title: "How TransXT is Revolutionising B2B Payments in India | 86400 Fintech",
    description: "Discover how TransXT simplifies B2B payments with real-time tracking, API integrations, and automated reconciliation — empowering businesses across India.",
    keywords: "B2B payments India, Digital payment platform, API payment gateway, Fintech solutions, IMPS API integration, Fintech infrastructure India"
  },

  "/Blogs/53": {
    title: "The Value of 86400: Powering India’s Fintech & Digital Payment Infrastructure",
    description: "Discover how 86400 simplifies digital payments through API-based infrastructure, secure compliance, and scalable fintech solutions for banks and enterprises.",
    keywords: "digital payments, UPI integration, fintech API platform, fintech solutions, API-based payment systems"
  },

  "/Blogs/60": {
    title: "From Transactions to Trust: How Payments Will Evolve in 2026 | 86400",
    description: "Explore how payments will evolve in 2026 as trust, AI-driven risk management, embedded finance, and resilient infrastructure redefine digital transactions. Insights on UPI growth, predictive systems, and secure payment ecosystems by 86400.",
    keywords: "Future of payments 2026, UPI growth 2025, UPI Lite X, digital payments India, AI in payments, predictive payments, embedded finance, payment infrastructure, secure payment systems, trust in fintech, 86400 blog"
  }
};